import { getFunctions, httpsCallable } from "firebase/functions";

export const createAuthAccount = async (email, displayName, role, nickname = undefined) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "createAuthAccount");
  const result = await callableFunction({ email, displayName, role, nickname });
  return result.data;
};

export const updateAuthAccount = async (userId, email, displayName, role, nickname = undefined) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "updateAuthAccount");
  const result = await callableFunction({ userId, email, displayName, role, nickname });
  return result.data;
};

export const deleteAuthAccount = async (userId) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "deleteAuthAccount");
  const result = await callableFunction({ userId });
  return result.data;
};

export const verifyPasswordResetToken = async (token) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "verifyPasswordResetToken");
  const result = await callableFunction({ token });
  return result.data;
};

export const resetPassword = async (token, password) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "resetPassword");
  const result = await callableFunction({ token, password });
  return result.data;
};

export const sendResetPasswordEmail = async (email) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "sendResetPasswordEmail");
  const result = await callableFunction({ email });
  return result.data;
};

export const verifyQuestionnaireToken = async (token) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "verifyQuestionnaireToken");
  const result = await callableFunction({ token });
  return result.data;
};

export const submitQuestionnaireWithToken = async (token, answers) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "submitQuestionnaireWithToken");
  const result = await callableFunction({ token, answers });
  return result.data;
};

export const determineCentileRank = async (age, gender, avgHandGripStrength) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "determineCentileRank");
  const result = await callableFunction({ age, gender, avgHandGripStrength });
  return result.data;
};

export const generatePatientRole = async (hospitalId) => {
  const functions = getFunctions();
  const callableFunction = httpsCallable(functions, "generatePatientRole");
  const result = await callableFunction({ hospitalId });
  return result.data;
};